import React, { useContext } from "react";

import { useTranslation } from "@root/misc/useTranslation";

import { LineupContext } from "../../context/LineupContext";
import { usePickerContext } from "../../context/PickerContext";
import { usePickerStateSelector } from "../../context/pickerState";

import { PickedOption } from "./PickedOption";

export const TopBar = () => {
  const slot = usePickerStateSelector((state) => state.openFor?.slot);

  const { lineup, getSlotIfPicked } = useContext(LineupContext);

  const { forceClose } = usePickerContext();

  const i18n = useTranslation();

  const currentOptionInSlot =
    (slot && getSlotIfPicked(slot)?.pickedOption) || undefined;

  if (!lineup) {
    return null
  }

  return (
    <div className="neo__lineupPicker__topBar">
      <div className="neo__lineupPicker__topBar__column">
        <div className="neo__lineupPicker__pucks">
          <div className="neo__lineupPicker__option__infoPricePuk" />
          <strong>{lineup.budget_left}</strong>
          <span>{"/" + lineup.total_budget}</span>
        </div>
      </div>
      {slot && getSlotIfPicked(slot) && (
        <PickedOption option={currentOptionInSlot} />
      )}
      <div className="neo__lineupPicker__topBar__column">
        <a
          className="neo__lineupPicker__closeIcon"
          role="button"
          title={i18n.t("lineup_picker.action_close")}
          onClick={forceClose}
        />
      </div>
    </div>
  );
};
